<template>
    <div class="font_Montserrat v3_color_black_knight study-header">
        <!-- Section progress bar -->
        <b-row>
            <b-col md="12" sm="12">
                <p class="v2_font_weight_bold font_size_1500rem">
                    {{ pageTitle }}
                </p>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12" sm="12">
                <p class="font_size_1000rem">
                    {{ this.content }}
                </p>
            </b-col>
        </b-row>
        <div class="study-form-container">
            <b-container class="survey-form pt-3">
                <v-wait :for="loaderId">
                    <HalfCircleSpinner slot="waiting"/>
                    <template slot="waiting">
                        <div class="spinner-message my-3 text-center">Loading...</div>
                    </template>
                    <b-row>
                        <!-- <b-col md="12" sm="12">
                            <b-button
                                    variant="kowloon"
                                    class="mr-2 mb-2 mb-lg-0 begin-study"
                                    @click="onStudyClick"
                            >
                            Begin Study
                            </b-button>
                        </b-col> -->
                        <b-col class="order-1">
                            <div class="survey-form__body prior-year-main-div" v-cloak>
                                <!------------ Profile Data--------------->
                                <table class="table">
                                    <template>
                                        <thead>
                                            <tr>
                                                <th>Profile</th>
                                                <th>Prior Response</th>
                                                <th>Update?</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="dvm in derivedVariables" :key="dvm.derivedVariable.name">
                                                <td>  {{ dvm.derivedVariable.title=='Location' ? 'Practice Zip Code' : dvm.derivedVariable.title }}</td>
                                                <td> {{ (dvm.derivedVariable.name=='userVisaStatus') ? userVisaStatus : (dvm.derivedVariable.name=='userEthnicity' ? user.ethnicity[0] : (dvm.derivedVariable.name=='userZipcode') ? user.practice_zip : '') }}</td>
                                                <td> 
                                                    <b-form-checkbox
                                                        v-model="selected"
                                                        class="v2_control_checkbox_small display-flex"
                                                        :value="dvm.derivedVariable.name"
                                                        :disabled="dvm.isDisabled"
                                                    >
                                                    <!-- <b-form-checkbox
                                                        v-model="selectedVariables"
                                                        class="v2_control_checkbox_small display-flex"
                                                        :value="dvm.derivedVariable.name"
                                                        > -->
                                                    </b-form-checkbox>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>  Board Certification </td>
                                                <td> {{ user.has_board_certification==1 ? "Yes" : 'No'}}</td>
                                                <td> 
                                                    <b-form-checkbox
                                                        class="v2_control_checkbox_small display-flex"
                                                        v-model="selected"
                                                        value="userBoardCertification"
                                                    >
                                                    </b-form-checkbox>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>State of License(s)</td>
                                                <td>{{ this.getLicensedState(user.licensed_states) }}</td>
                                                <td> 
                                                    <b-form-checkbox
                                                        class="v2_control_checkbox_small display-flex"
                                                        v-model="selected"
                                                        value="licensedStates"
                                                        :disabled = "!this.getLicensedState(user.licensed_states) ? true : false"
                                                    >
                                                    </b-form-checkbox>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </table>
                                <!------------ Study Questions --------------->
                                <table class="table" v-if="this.questionData">
                                    <template>
                                        <thead>
                                            <tr>
                                                <th>Study Questions</th>
                                                <th>Prior Response</th>
                                                <th>Update?</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="que in this.questionData" :key="que.question.id">
                                                <td>{{ que.question.prompt }}</td>
                                                <td :style="{ whiteSpace: 'pre-line', padding: '0', margin: '0' }">
                                                    {{ que.question.response_value ? que.question.response_value : (que.question.relatedJobQuestion ? que.question.relatedJobQuestion.response_value : '') }}
                                                </td>
                                                <td> 
                                                    <b-form-checkbox  class="v2_control_checkbox_small display-flex"  :id="'checkbox_' + que.question.id" v-model="selectedQuestions" :value="que.question.id"></b-form-checkbox>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </table>
                                <div>
                                    <p class="text-white">{{ selectedQuestions }} - {{ getSelectedQuestions }}</p>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="12" sm="12" class="update-response-btn">
                            <b-button
                                    variant="kowloon"
                                    class="mr-2 mb-2 mb-lg-0"
                                    @click="onStudyClick"
                            >
                            Update Response
                            </b-button>
                        </b-col>
                    </b-row>
                    <!----- New ICO Modal Start ----->
                    <b-modal
                        size="xl"
                        centered
                        hide-footer
                        header-class="job-profile-summary-header justify-content-start"
                        body-class="v2_font_size_18"
                        no-close-on-backdrop
                        no-close-on-esc
                        :visible="isNewIcoModalVisible"
                        :hide-header-close="survey.submitted"
                >
                            <template>
                            <template slot="modal-header-close"><div></div></template>
                            <fragment v-if="!survey.submitted">
                                <b-row class="mt-2 submitted-survey-container">
                                    <b-col cols="12">
                                        <job-profile-title-intial-card            
                                            @cancel="onCancelNewJobProfile"            
                                            @form-submit="onRenameJobProfile"
                                        />
                                    </b-col>
                                </b-row>
                            </fragment>
                            </template>
                    </b-modal>
                    <!----- New ICO Modal Start ----->
                </v-wait>
            </b-container>
        </div>
        <b-modal
        size="xl"
        :visible="isUserProfilePopupVisible"
        class="v3_modal"
        :header-class="'align-items-center border_0'"
        :body-class="'p-0'"
        hide-footer
        @hidden="isUserProfilePopupVisible = false"
        >
        <!-- <template slot="modal-header">
            <h2 class="font_size_1125rem">User Profile</h2>
            <div class="d-flex align-items-center justify-content-between">
            <b-button variant="v3_teal_outline" @click="onUserProfileSave">
                <template v-if="!userProfilePopupLoading">Save & Next</template>
                <b-spinner v-else small />
            </b-button>
            <b-button
                variant="v3_red_outline"
                class="ml-3"
                @click="isUserProfilePopupVisible = false"
            >
                Cancel
            </b-button>
            </div>
        </template> -->
        <update-profile-form-for-study
            ref="userProfileModal"
            @profile-form-submit="onProfileSubmit"
            @profile-form-cancel="isUserProfilePopupVisible = false"
            @validate-failed="userProfilePopupLoading = false"
            :selectedProfileQuestions="selected"
            :fromPriorStudy="true"
            @on-user-profile-save="onUserProfileSave"
            @close = "close"
        />
        </b-modal>

        <b-modal
        size="xl"
        :visible="IcoPopVisible"
        class="v3_modal"
        :header-class="'align-items-center border_0'"
        :body-class="'p-0'"
        hide-footer
        @hidden="IcoPopVisible = false"
        >
        <template>
            <IcoInfoPopupContent 
            :defaultQuestionData="this.getPriorQuestionnaireJobQuestions() ? this.getPriorQuestionnaireJobQuestions() : []"
            @handle-go-to-dashboard="handleGoToDashboard"
            @handle-ico-in-edit-mode="handleIcoInEditMode"
            @handle-create-new-ico="handleCreateNewIco"
            />
        </template>
        </b-modal>

    </div>
</template>

<!-- -------------------------------------------------------- -->

<script>
import Api, {didAbort} from '@/providers/Api.js';
import {HalfCircleSpinner} from 'epic-spinners';
import {
    GET_SURVEY_ACTION,
    QUESTION_TYPES,
    VISA_STATUSES_LABELS,
    SET_USER_DEFAULT_JOB_PROFILE_MUTATION
} from '@/store';
import {
    getSectionApplicableCount,
    getSectionCompletedOrDeclinedCount
} from '@/helpers/questionnaireHelper';
import {createGeographyQuestionObjectFromJobProfile} from '@/helpers/jobQuestionsHelper';
import {CREATE_JOB_PROFILE_ACTION,UPDATE_JOB_PROFILE_ACTION} from '@/store/jobProfiles';
import Questionnaire from '@/providers/Questionnaire.js';
//import UserProfileForm from '@/components/users/profile/UserProfileForm';
import UpdateProfileFormForStudy from '@/components/users/profile/UpdateProfileFormForStudy';
import IcoInfoPopupContent from '@/components/study/IcoInfoPopupContent';
import {handleServerErrorWithValidation} from '@/helpers/ToastedHelper';
import JobProfileTitleIntialCard from '@/components/exchange/job-profile-details/JobProfileTitleIntialCard';
import states from '@/providers/States.js';

const pageSubHeadingText = "Your anonymous responses to the prior year’s Study are listed below. Tick the box for any response you would like to update and click “Update Response” to enter that new information.";

const activityEvents = [
    'mousedown',
    'mousemove',
    'keydown',
    'scroll',
    'touchstart',
];

const profileFields = [
    'Practice Zip Code',
    'Board Certification',
    'Visa Status',
];

export default {
    name: 'UpdatePriorYearStudy',
    components:{
        HalfCircleSpinner,
        UpdateProfileFormForStudy,
        IcoInfoPopupContent,
        JobProfileTitleIntialCard
    },
    data: function () {
        return {
            survey: {},
            priorquestionnaireid: null,
            prior_survey: null,
            completeSurveFlag:false,
            content: null,
            priorQueIds: null,
            currentQueIds: null,
            filterQuestionIds: null,
            questionData: [],
            selectedQuestions: [],
            selected: [],
            beginLoading: false,
            isUserProfilePopupVisible: false,
            userProfilePopupLoading: false,
            IcoPopVisible: false,
            isNewIcoModalVisible: false,
            geographicJobQuestion: null,
            surveyId : null,
            combinedJsonArray: [],
            isDisabled: false
        };
    },
    props: {
        society: Object,
        questionnaire: {
            validator: (prop) => typeof prop === 'object' || prop === null,
            default: null,
        },
        study: {
            validator: (prop) => typeof prop === 'object' || prop === null,
            default: null,
        },
    },
    created: function () {
        ////// load new servey questionnarire ////////
        this.loadSurvey();
        this.content = pageSubHeadingText;
        this.profileFields = profileFields;
        this.geographicJobQuestion = createGeographyQuestionObjectFromJobProfile(
            this.defaultJobProfile
        );
    },
    beforeMount: function () {
        window.addEventListener('beforeunload', this.preventEventIfDirtyOrErrors);
    },
    mounted: function () {
        this.surveyId = this.$route.params.surveyId;
        //add these events to the document.
        //register the activity function as the listener parameter.
        activityEvents.forEach((eventName) => {
            document.addEventListener(
                eventName,
                this.updateUserLastActivityTime,
                true
            );
        });
    },
    beforeDestroy: function () {
        //document.removeEventListener('scroll', this.calculateIsJobQuestionVisible);
        window.removeEventListener(
            'beforeunload',
            this.preventEventIfDirtyOrErrors
        );
        clearInterval(this.$options.takingStudyInterval);
        activityEvents.forEach((eventName) => {
            document.removeEventListener(
                eventName,
                this.updateUserLastActivityTime,
                true
            );
        });
    },
    computed: {
        pageTitle: function () {
            const questionnaire = (this.survey || {}).questionnaire;
            // this.priorquestionnaireid = questionnaire
            //     ? `${questionnaire.prior_year_questionnaire_id}`
            //     : ''; 
            this.setPriorquestionnaireId();
            return questionnaire
                ? `${questionnaire.period} ${questionnaire.title} - Update`
                : '';
        },
        loaderId: function () {
            return `loading_${this.$options.name}`;
        },
        user: function () {
            return this.$store.state.user;
        },
        derivedVariables: function () { 
            const selectedNames = [];
            const derivedVariables = Questionnaire.getDerivedVariables(selectedNames);
            
            let selectedValues = [];
            ////// userVisaStatus /////
            const userVisaStatusVal = derivedVariables.find(
                item => item.derivedVariable.name === "userVisaStatus"
            );
            if (userVisaStatusVal) {
                this.selected = [];
                if(!this.userVisaStatus){
                    selectedValues.push("userVisaStatus");
                    userVisaStatusVal.isDisabled = true;
                }
            }

            ////// userEthnicity /////
            const userEthnicityVal = derivedVariables.find(
                item => item.derivedVariable.name === "userEthnicity"
            );
            if (userEthnicityVal) {
                this.selected = [];
                if(!this.user.ethnicity[0]){
                    selectedValues.push("userEthnicity");
                    userEthnicityVal.isDisabled = false;
                }
            }

            ////// userZipcode /////
            const userZipcodeVal = derivedVariables.find(
                item => item.derivedVariable.name === "userZipcode"
            );
            if (userZipcodeVal) {
                this.selected = [];

                if(!this.user.practice_zip){
                    selectedValues.push("userZipcode");
                    userZipcodeVal.isDisabled = true;
                }
            }
            if(!this.getLicensedState(this.user.licensed_states)){
                selectedValues.push("licensedStates");
            }
            this.selected = selectedValues;
            this.combinedJsonArray = [userVisaStatusVal, userEthnicityVal,userZipcodeVal];
            return this.filteredDerivedVariables(this.combinedJsonArray);
            //return this.filteredDerivedVariables(derivedVariables);
        },
        selectedVariables() {
            return this.derivedVariables.map(dvm => dvm.derivedVariable.name);
        },
        userVisaStatus: function () {
            const visaStatus = Object.keys(VISA_STATUSES_LABELS).map((key) => ({
                value: key,
                text: VISA_STATUSES_LABELS[key],
            }));
            const uvs = this.user.visa_status ? visaStatus.find(vs => vs.value === this.user.visa_status) : '';
            return uvs ? uvs.text : '';
        },
        isModuleQuestionnaire: function () {
            return this.$route.params.sectionId;
        },
        getSelectedQuestions() {
            this.changeResponseQuestionId();
            return this.selectedQuestions;
            // if(this.questionData)
            // {
            //     ///// CHANGED RESPONSE SET questions //////
            //     this.selectedQuestionsResponseSet();
            //     ///// NOT CHANGED RESPONSE SET questions //////
            //     this.deselectedQuestionsResponseSet();
            //     ///// Change 
            //     this.getChangedResponseSetQuestions();
            //     const newQueSet = this.newQuestionSet();
            //     this.$store.state.setPriorQuestions = this.survey;
            //     // if(this.survey && this.selectedQuestions.length > 0)
            //     // {
            //     //     this.survey.questionnaire.sections.forEach(surveyQuestion => {
            //     //     });
            //     // }
            // }
        },
        defaultJobProfile: {
            get: function () {
                return this.$store.getters.userDefaultJobProfile;
            },
            set: function (data) {
                this.$store.commit(SET_USER_DEFAULT_JOB_PROFILE_MUTATION, data);
            },
        },
    },
    methods: {
        isValueBlank(dvm) {
            const value = dvm.name === 'userVisaStatus' ? this.userVisaStatus
                        : dvm.name === 'userEthnicity' ? this.user.ethnicity[0]
                        : dvm.name === 'userZipcode' ? this.user.practice_zip
                        : '';
            return value === '';
        },
        async fetchPriorData() {
            try {
                if (this.prior_survey !== null) {
                    await this.loadPriorSurvey();
                }
                // Continue with your other code...
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        },
        onStudyClick: function () {
            this.beginStudy();
        },
        matchingPriorQuetionWithCurrentQuetionnaire() {
            return this.currentQueIds.filter(value => !this.priorQueIds.includes(value));
        },
        beginStudy: async function () {
            this.beginLoading = true;
            if(this.selectedQuestions.length == 0 && this.matchingPriorQuetionWithCurrentQuetionnaire().length == 0){
                this.IcoPopVisible = true;
            }else{
                try {
                    if(this.selected.length > 0)
                    {
                        this.isUserProfilePopupVisible = true;
                    }else{
                        this.$router.push(`/surveyForm/${this.survey.id}`);
                    } 
                } catch (e) {
                    handleServerErrorWithValidation(e, this.$toasted);
                } finally {
                    this.beginLoading = false;
                }
            }
            
        },
        onUserProfileSave: function () {
            this.userProfilePopupLoading = true;
            this.$refs.userProfileModal &&
            typeof this.$refs.userProfileModal.save === 'function' &&
            this.$refs.userProfileModal.save();
            this.$router.push(`/surveyForm/${this.survey.id}`);
        },
        onProfileSubmit: function () {
            this.userProfilePopupLoading = false;
            this.isUserProfilePopupVisible = false;
            this.beginStudy();
        },
        close: function () {
            this.userProfilePopupLoading = false;
            this.isUserProfilePopupVisible = false;
        },
        selectedQuestionsResponseSet(){
            const foundQuestions = this.questionData.filter(question => this.selectedQuestions.includes(question.question_id));
            if(foundQuestions){
                foundQuestions.forEach(foundQuestion => {
                    const matchingQuestion = this.questionData.find(question => question.question_id === foundQuestion.question_id);
                    if (matchingQuestion) {
                        matchingQuestion.response_set = "CHANGED RESPONSE SET";
                    }else{
                        matchingQuestion.response_set = "NOT CHANGED RESPONSE SET";
                    }
                });
            }
        },
        deselectedQuestionsResponseSet(){
            const excludedQuestions = this.questionData.filter(question => !this.selectedQuestions.includes(question.question_id));               
                 if(excludedQuestions){
                    excludedQuestions.forEach(excludedQuestion => {
                        const matchingQuestion = this.questionData.find(question => question.question_id === excludedQuestion.question_id);
                        if (matchingQuestion) {
                            matchingQuestion.response_set = "NOT CHANGED RESPONSE SET";
                        }else{
                            matchingQuestion.response_set = "NOT CHANGED RESPONSE SET";
                        }
                    });
                }
        },
        getChangedResponseSetQuestions() {
            return this.questionData.filter(question => question.response_set === "CHANGED RESPONSE SET");
        },
        questionSections() {
            const sections = this.prior_survey ? this.prior_survey.survey.questionnaire.sections || [] : [];
            const flattenedSections = sections.reduce((acc, section) => {
                return acc.concat(section.questionSections || []);
            }, []);
            this.$store.state.loadDefaultSurveyData = flattenedSections;
            //console.log(JSON.stringify(flattenedSections));
            return flattenedSections;
        },
        questions: function () {
            this.priorQueIds = this.questionIds(this.questionSections());
            return this.priorQueIds;
        },
        priorQuestionsData: function () {
          
            // const surveyQuestions = this.questionSections().flatMap((s) =>
            //     Array.isArray(s.questionSections)
            //         ? s.questionSections.map((qs) => qs.question)
            //         : []
            //);
           
            const surveyQuestions = this.questionSections().map(item => {
            if (item.question) {
                return item.question;
            }
            });

            // Filter out undefined values from the array
            const surveyQue = surveyQuestions.filter(question => question !== undefined);

            // 'questions' will contain an array of 'question' objects

            //const surveyQuestions = this.questionSections().map(item => item.question);
            surveyQue.push(
                {
                    id: Date.now(),
                    type: QUESTION_TYPES.GEOGRAPHY_ICO_WRAPPER,
                    variables: [],
                    relatedJobQuestion: this.geographicJobQuestion,
            });
            //console.log(JSON.stringify(surveyQue));
            return surveyQue;
        },
        getPriorQuestionnaireJobQuestions: function () {
            let ques = this.priorQuestionsData().filter(item => item.relatedJobQuestion !== null);
            return ques.reduce((result, {relatedJobQuestion}) => {
                if (relatedJobQuestion) {
                    result.push({...relatedJobQuestion});
                }
                return result;
            }, []);
        },
        questionIds(questionData) {
            return questionData.map(question => question.question_id);
        },
        questionCurrentSections() {
            const sections = this.survey.questionnaire.sections || [];
            const flattenedSections = sections.reduce((acc, section) => {
                return acc.concat(section.questionSections || []);
            }, []);
            return flattenedSections;
        },
        currentQuestions: function () {
            this.currentQueIds = this.currentQuestionIds(this.questionCurrentSections());
            return this.currentQueIds;
        },
        currentQuestionIds(questionData) {
            return questionData.map(question => question.question_id);
        },
        filterIds() {
            this.questions();
            this.currentQuestions();
            this.filterQuestionIds = this.currentQueIds.filter(id => this.priorQueIds.includes(id));
        },
        filteredDerivedVariables(derivedVariables) {
            return derivedVariables.filter(item => !["userSpecialtyId", "userGender","userUSVeteran"].includes(item.derivedVariable.name));
        },
        loadPriorQuestionnarire: function () {
            if(this.priorquestionnaireid)
            {
                this.loadPriorSurvey();
            }
        },
        loadPriorSurvey: async function () {
            if(this.priorquestionnaireid){
                try {
                    const prior_survey_data = await Api.getSurveyDetailsByQuestionnaireidAndUserid(
                    this.user.id,this.priorquestionnaireid
                    );
                    if(!prior_survey_data){
                        return null;
                    }
                    const surveyId = prior_survey_data.id;
                    const sectionId = null;

                    // let surveyData = !sectionId
                    //     ? this.$store.getters.getSurveyData(surveyId)
                    //     : null;
                    let surveyData = null;
                    if (!surveyData) {
                        this.$wait.start(this.loaderId);
                        try {
                            surveyData = await this.$store.dispatch(GET_SURVEY_ACTION, {
                                surveyId,
                                sectionId,
                            });
                        } catch (error) {
                            this.$wait.end(this.loaderId);
                            process.env.NODE_ENV !== 'production' && console.error(error);
                            this.$toasted.show('Some error occurs', {
                                type: 'error',
                                duration: 3000,
                            });
                        }
                    }
                   
                    this.prior_survey = surveyData;
                    this.$store.state.setPriorSurvey = this.prior_survey;
                    if(this.prior_survey)
                    {
                        this.questionData = this.filteredQuestions();
                        if(this.questionData)
                        {
                            if(this.questionData)
                            {
                                this.questionData.forEach((question) => {
                                    let filteredVariables = question.question.variables.filter(variable => variable.response.value !== null && variable.response.value !== 0);
                                    if(filteredVariables){
                                        let labels = '';
                                        let resYesNo = filteredVariables.some(item => item.response.value === "1");
                                        filteredVariables.forEach((fv) => {

                                            let res_suffix = fv.suffix ? fv.suffix : '';
                                            let res_input_label = fv.input_label ? fv.input_label : '';
                                            let res_prefix = fv.prefix ? fv.prefix : '';

                                            if(question.question.type == 'SLIDER'){
                                                labels += fv.response.value ? res_prefix + fv.response.value + res_suffix + ' ' + res_input_label + '\n' : '';
                                            }else if(question.question.type == 'YES_NO'){
                                                if(question.question.variables.length > 1){
                                                    if(resYesNo == true){
                                                        labels = 'Yes';
                                                    }else{
                                                        labels = 'No';
                                                    }
                                                }else{
                                                    labels += (fv.response.value && fv.response.value == 1) ? 'Yes\n' : ((fv.response.value && fv.response.value == 0) ? 'No\n' : '');
                                                }
                                            }else{
                                                labels += fv.input_label ? res_prefix + fv.input_label + res_suffix + '\n' : '';
                                            }
                                            //question.question.response_value = labels;
                                        });
                                        question.question.response_value = labels;
                                    }
                                    if(question.question.relatedJobQuestion != null)
                                    {
                                        let defaultLables = '';
                                        question.question.relatedJobQuestion.jobQuestionVariables.forEach((jobQuestionVariable) => {

                                            let res_suffix = jobQuestionVariable.suffix;
                                            let res_input_label = jobQuestionVariable.input_label;
                                            if(question.question.type == 'SLIDER'){
                                                question.question.relatedJobQuestion.response_value = jobQuestionVariable.jobProfileQuestionResponses[0].value + ' ' + res_suffix + '-' + res_input_label;
                                                defaultLables += jobQuestionVariable.jobProfileQuestionResponses[0].value + '\n';
                                            }else if(question.question.relatedJobQuestion.talent_type == 'YES_NO'){
                                                defaultLables += (Math.floor(jobQuestionVariable.jobProfileQuestionResponses[0].value) == 1) ? jobQuestionVariable.input_label + '\n' : '';
                                            }else{
                                                question.question.relatedJobQuestion.response_value = jobQuestionVariable.jobProfileQuestionResponses[0].value ? jobQuestionVariable.input_label : '';
                                                defaultLables += jobQuestionVariable.jobProfileQuestionResponses[0].value ? jobQuestionVariable.input_label + '\n' : '';
                                            }
                                            question.question.relatedJobQuestion.response_default_value = defaultLables;
                                        });
                                    }
                                    /*else{
                                        question.question.relatedJobQuestion.response_default_value = null;
                                    }*/
                                });
                            }
                            if(this.questionData.length > 0)
                            {
                                this.savePriorQuestionnaireDefaultResponse(this.surveyId,this.questionData);
                            }
                            this.$store.state.setPriorQuestions = this.questionData;
                        }
                    }
                    this.$wait.end(this.loaderId);
                } catch (error) {
                    if (!didAbort(error)) {
                        handleServerErrorWithValidation(error, this.$toasted);
                    }
                }
            }         
        },
        savePriorQuestionnaireDefaultResponse: async function (surveyId,notChangeQuestions = []) {
            try {
                await Api.savePriorQuestionnaireDefaultResponse(
                    surveyId,
                    notChangeQuestions
                );
                await Api.updateUser(this, this.$store.state.user);
            } catch (error) {
                if (!didAbort(error)) {
                    handleServerErrorWithValidation(error, this.$toasted);
                }
            }
        },
        filteredQuestions() {
            this.filterIds();
            if(!this.questionCurrentSections()) return [];
            if(!this.filterQuestionIds)  return this.questionCurrentSections();
            return this.questionSections().filter(question => this.filterQuestionIds.includes(question.question_id));
        },
        newQuestionSet() {
           return this.questionCurrentSections();
        },
        loadSurvey: async function () {
            const {surveyId, sectionId = null} = this.$route.params;
            // let surveyData = !sectionId
            //     ? this.$store.getters.getSurveyData(surveyId)
            //     : null;
            let surveyData = null;
            if (!surveyData) {
                this.$wait.start(this.loaderId);
                try {
                    surveyData = await this.$store.dispatch(GET_SURVEY_ACTION, {
                        surveyId,
                        sectionId,
                    });
                } catch (error) {
                    this.$wait.end(this.loaderId);
                    process.env.NODE_ENV !== 'production' && console.error(error);
                    this.$toasted.show('Some error occurs', {
                        type: 'error',
                        duration: 3000,
                    });
                }
            }
            const {survey} = surveyData || {};
            /// fetch prior uestionnarire /////
            const questionnaire = (survey || {}).questionnaire;
         
            this.priorquestionnaireid = questionnaire
                ? `${questionnaire.prior_year_questionnaire_id}`
                : ''; 

            if(this.priorquestionnaireid)  this.loadPriorQuestionnarire();
           
            if (survey.submitted && !sectionId) {
                this.$router.push({name: 'studies'});
            }
            this.survey = survey;
           
            this.$wait.end(this.loaderId);
        },
        preventEventIfDirtyOrErrors: function (event) {
           // if (!this.$v.$anyDirty) return;
            event.preventDefault();
            event.returnValue = '';
        },
        setPriorquestionnaireId: function () {
            const questionnaire = (this.survey || {}).questionnaire;
            this.priorquestionnaireid = questionnaire
                ? `${questionnaire.prior_year_questionnaire_id}`
                : ''; 
        },
        changeResponseQuestionId: function () {
            this.$store.state.changeResponseQuestionIds = this.selectedQuestions;
            if(this.priorQueIds)
            {
                const notChangeIds = this.priorQueIds.filter(value => !this.selectedQuestions.includes(value));
                this.$store.state.priorQuestionIds = notChangeIds;
            }
        },
        // getDesiredLocationDisplayName: function () {
        //     let geographicJobQuestion = createGeographyQuestionObjectFromJobProfile(
        //         this.defaultJobProfile
        //     );

        //     let location = null;
        //     if(geographicJobQuestion){
        //         location =  geographicJobQuestion.jobQuestionVariables[0] ? geographicJobQuestion.jobQuestionVariables[0].jobProfileQuestionResponses[0].value.display_name : '';
        //     }

        //     return location;
        // },
        getDefaultQuestionData: function () {
            return this.$store.state.setPriorQuestions;
        },
        removePriorStore: function () {
            this.$store.state.priorQuestionIds = undefined;
            this.$store.state.changeResponseQuestionIds = undefined;
            this.$store.state.setPriorSurvey = undefined;
        },
        getSurveyCompleteRatio() {
            const completeSectionCount = this.sections.filter(
                (s) =>
                    getSectionCompletedOrDeclinedCount(
                        s,
                        this.variables,
                        this.survey.questionnaire.is_support_job_preference
                    ) === getSectionApplicableCount(s, this.variables)
            ).length;
            return completeSectionCount + '/' + this.sections.length;
        },
        renameJobProfile: async function () {
            // eslint-disable-next-line no-unused-vars
            const {jobQuestions, ...restProfileData} = this.defaultJobProfile || {};
            const profile = await this.$store.dispatch(UPDATE_JOB_PROFILE_ACTION, {
                ...restProfileData,
            });
            this.defaultJobProfile = {
                ...this.profile,
                ...profile,
            };
        },
        updateSurvey: async function (submit = false) {
            this.survey.sections_completed = this.getSurveyCompleteRatio();
            const responses = this.getResponses();
            try {
                await Api.updateSurvey(
                    this,
                    {
                        ...this.survey,
                        responses: responses,
                    },
                    submit,
                    this.$route.params.sectionId || null
                );
                await Api.updateUser(this, this.$store.state.user);
            } catch (error) {
                if (!didAbort(error)) {
                    handleServerErrorWithValidation(error, this.$toasted);
                }
            }
        },
        onReviewICOSubmitSurvey: async function () {
            await this.renameJobProfile();
            try {
                const {data: updatedSurvey} = await Api.updateSurvey(
                    this,
                    this.survey,
                    true
                );
                this.survey.submitted = updatedSurvey.submitted;
                await Api.updateUser(this, this.$store.state.user, true);
            } catch (error) {
                handleServerErrorWithValidation(error, this.$toasted);
            } finally {
                this.submitLoading = false;
            }
        },
        handleGoToDashboard: function () {
            this.completeSurveFlag = true;
            this.onReviewICOSubmitSurvey();
            //// remove prior data storage /////
            this.removePriorStore();
            this.$router.push(`/user/dashboard`);
        },
        handleIcoInEditMode: async function () {
            this.completeSurveFlag = true;
            this.onReviewICOSubmitSurvey();
            //// remove prior data storage /////
            this.removePriorStore();
            const getDefaultProfile = await Api.getDefaultJobProfile(
                this.user.id
            );
            if(getDefaultProfile){
                this.$router.push(`/exchange/job-profile/${getDefaultProfile.id}`); 
            }else{
                this.$router.push(`/user/dashboard`); 
            }
        },
        handleCreateNewIco: function () {
            this.isNewIcoModalVisible = true;
        },
        onCancelNewJobProfile: function () {      
            this.isNewIcoModalVisible = false;   
        },
        onRenameJobProfile: async function (newTitle) {
            // eslint-disable-next-line no-unused-vars
            this.$wait.start('menu-loading');
        
            const newProfile = await this.$store.dispatch(
                CREATE_JOB_PROFILE_ACTION,
                { title: newTitle }
                );
                
                this.$router.push({
                name: `jobProfilePage`,
                params: {
                    isNew: true,
                    id: (newProfile || {}).id,
                },
                });
            this.completeSurveFlag = true;
            this.onReviewICOSubmitSurvey();
            //// remove prior data storage /////
            this.removePriorStore();
            this.$wait.end('menu-loading');
        },
        getLicensedState : function (stateList){
            const selectedStates = stateList.map(key => states.states[key]);
            return selectedStates.join(', ');            
        }
    }
}
</script>

<style lang="scss">
    .prior-year-main-div th, .prior-year-main-div td{
        width:33%;
    }
    .display-flex{
        display: flex !important;
    }
    .begin-study{
        margin: 0 auto !important;
        margin-bottom: 0px;
        display: block !important;
        margin-bottom: 15px !important;
    }
    .update-response-btn{
        display:block;text-align:center;
        margin-bottom: 2rem;
    }
  </style>

        